import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';

import { Text } from './Typography';

// Closed primitive: a single <Avatar img alt /> exposes the whole shape.
// `alt` is required and doubles as the visible fallback rendered when
// `img` is missing or fails to load — so pass a *short* string (e.g.
// "JS", "John", a 1-2 letter abbreviation), not a full sentence.
// Radix's Image + Fallback subparts are wrapped internally.

const Avatar = React.forwardRef(({ alt, className: _className, img, style: _style, ...props }, ref) => {
    if (!alt) {
        throw new Error('Avatar: `alt` is required.');
    }

    return (
        <AvatarPrimitive.Root
            ref={ref}
            className="tw-relative tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-overflow-hidden tw-rounded-full tw-border tw-border-border tw-bg-muted"
            {...props}
        >
            {img ? (
                <AvatarPrimitive.Image
                    alt={alt}
                    className="tw-aspect-square tw-h-full tw-w-full"
                    src={img}
                />
            ) : null}
            <AvatarPrimitive.Fallback className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-rounded-full tw-bg-muted tw-text-foreground">
                <Text tone="inherit" variant="overline">{alt}</Text>
            </AvatarPrimitive.Fallback>
        </AvatarPrimitive.Root>
    );
});

Avatar.displayName = 'Avatar';

export { Avatar };
